import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function ImageIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 13.56 13.52"
      style={{ width: `16px`, height: `16px`, color: RoutalPalette.primary40, ...props.style }}
    >
      <g id="uuid-cabc18ec-159d-4f53-8678-4e9ef926e1c8">
        <g id="uuid-2849f151-5ab5-4101-8848-e3f18f795cda">
          <g id="uuid-adefd7cf-48ae-4cdd-9304-392bafac3248">
            <path
              id="uuid-f6a731bf-e5b8-40e6-a7ce-919c04e03eb8"
              d="M11.45,13.38H2.11c-.95,0-1.76-.67-1.93-1.61,0-.02,0-.04,0-.06-.02-.1-.02-.2-.02-.29V2.08c0-1.08.88-1.95,1.96-1.96h9.34c1.08,0,1.96.88,1.96,1.96v9.35c0,1.08-.87,1.96-1.95,1.96,0,0,0,0,0,0h0ZM1.01,11.81c.16.47.6.78,1.1.78h9.34c.64,0,1.16-.52,1.16-1.16v-2.81l-1.18-1.18s-.07-.06-.11-.1c-.42-.26-.96-.23-1.34.08l-2.06,1.65c-.66.54-1.6.58-2.31.1l-.4-.26c-.44-.29-1.02-.25-1.41.1l-2.8,2.8h0ZM2.11.92c-.64,0-1.16.52-1.16,1.16v8.66l2.32-2.32c.67-.59,1.65-.67,2.4-.18l.4.26c.42.28.97.25,1.36-.06l2.06-1.64c.66-.53,1.58-.57,2.28-.12.09.06.17.13.24.2l.6.6V2.08c0-.64-.51-1.16-1.15-1.16H2.11ZM4.45,6.38c-1.08,0-1.96-.88-1.96-1.96,0-1.08.88-1.96,1.96-1.96,1.08,0,1.96.88,1.96,1.96,0,0,0,0,0,0,0,1.08-.88,1.96-1.96,1.96h0ZM4.45,3.26c-.64,0-1.16.52-1.16,1.16,0,.64.52,1.16,1.16,1.16s1.16-.52,1.16-1.16c0,0,0,0,0,0,0-.64-.52-1.16-1.16-1.16h0Z"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
